/* import __COLOCATED_TEMPLATE__ from './audience-filter.hbs'; */
/* RESPONSIBLE TEAM: team-data-foundations */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import type AiContentSegmentsService from 'embercom/services/ai-content-segments-service';
import { tracked } from '@glimmer/tracking';
import { scheduleOnce } from '@ember/runloop';
import { EntityType } from 'embercom/models/data/entity-types';

interface Args {
  onSelectionChange: (aiContentSegmentIds?: string[]) => void;
  selectedValues?: string[];
}

export default class WorkflowConnectorAudienceFilter extends Component<Args> {
  @service declare aiContentSegmentsService: AiContentSegmentsService;

  @tracked mutableSegmentIds: number[] = [];
  readonly entityType = EntityType.WorkflowConnectorAction;
  lastSyncedPropsString = '';

  constructor(owner: unknown, args: Args) {
    super(owner, args);
    if (!this.aiContentSegmentsService.isLoading) {
      this.loadAudienceSegments();
    }
    let initialIds = (this.args.selectedValues || []).map((id) => Number(id));
    this.mutableSegmentIds = initialIds;
    this.lastSyncedPropsString = JSON.stringify([...initialIds].sort());
  }

  private async loadAudienceSegments() {
    try {
      await this.aiContentSegmentsService.loadSegments();
    } catch (error) {
      console.error('Failed to load audience segments:', error);
    }
  }

  @action
  syncWithProps() {
    let propsIds = (this.args.selectedValues || []).map((id) => Number(id));
    let propsString = JSON.stringify([...propsIds].sort());

    if (this.lastSyncedPropsString === propsString) {
      return;
    }

    let currentString = JSON.stringify([...this.mutableSegmentIds].sort());
    if (currentString !== propsString) {
      this.mutableSegmentIds = propsIds;
    }

    this.lastSyncedPropsString = propsString;
  }

  performSearch = () => {
    let stringIds = this.mutableSegmentIds.map((id) => String(id));
    this.args.onSelectionChange(stringIds);
    this.lastSyncedPropsString = JSON.stringify([...this.mutableSegmentIds].sort());
  };

  @action
  handleSegmentChanged() {
    scheduleOnce('afterRender', this, this.performSearch);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'WorkflowConnector::AudienceFilter': typeof WorkflowConnectorAudienceFilter;
    'workflow-connector/audience-filter': typeof WorkflowConnectorAudienceFilter;
  }
}
